import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import QuickContactBanner from "@/components/feature/QuickContactBanner";
import ScrollToTop from "@/components/feature/ScrollToTop";
import PageFade from "@/components/feature/PageFade";
import CookieConsent from "@/components/feature/CookieConsent";
import SiteSchema from "@/components/feature/SiteSchema";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <SiteSchema />
        <ScrollToTop />
        <PageFade>
          <AppRoutes />
        </PageFade>
        <QuickContactBanner />
        <CookieConsent />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
